import React, {useEffect, useRef, useState} from "react";

import HeadingSecondary from "../components/ HeadingSecondary";
import DotLoading from "../components/DotLoading";
import SendMessageIcon from "../components/svg/SendMessageIcon";
import RefreshLogo from "../components/svg/RefreshLogo";
import authService from "../services/auth.service";
import profileService from "../services/profile.service";
import {toast, ToastContainer} from "react-toastify";
import {useForm} from "react-hook-form";
import {ContactUs} from "../validations/ContactUs";

type ContactUsForm = {
  name: string;
  email: string;
  description: string;
  captcha: string
};

const SettingContactUs: React.FC<any> = ({history}) => {
  // eslint-disable-next-line
  const [userLoginInfo, setUserLoginInfo] = useState({
    access_token: "",
    birthDate: "",
    expires_in: "",
    jti: "",
    mobileNumber: "",
    nationalId: "",
    refresh_token: "",
    scope: "",
    token_type: "",
  });

  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);
  const [captchaCode, setCaptchaCode] = useState("");
  const [inputCaptchaId, setInputCaptchaId] = useState("");
  const [successMessage, setSuccessMessage] = useState<any>(null);

  useEffect(() => {
    if (successMessage !== null) {
      toast.success("پیام شما با موفقیت ثبت شد.", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        progress: undefined,
      });
    }
  }, [successMessage]);

  // const nameRef = useRef<HTMLInputElement>(null);
  // useEffect(() => {
  //   nameRef.current!.focus();
  // }, [history]);

  const {
    register,
    handleSubmit,
    setFocus,
    formState: {errors},
    setError
  } = useForm<ContactUsForm>();

  const onSubmit = async (formData: ContactUsForm) => {
    const finalData = {
      captchaCode: formData.captcha,
      captchaId: inputCaptchaId,
      content: formData.description,
      name: formData.name,
      email: formData.email
    }
    console.log(formData);
    setIsLoading(true);
    try {
      // eslint-disable-next-line
      const {data} = await profileService.contactUs(finalData);

      setSuccessMessage("ok");
      // console.log(data);
    } catch (error: any) {
      if (error.response) {
        handleCaptcha();
        const {message} = error.response.data;
        if (message) {
          if (message.includes('captcha')) {
            return setError("captcha", {
              message: 'کد امنیتی اشتباه میباشد.'
            });
          }
        }

      } else if (error.request) {
        console.log("The request was made but no response was received");
      } else {
        console.log("Error", error.message);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleCaptcha = async () => {
    const {data} = await authService.captcha();
    setCaptchaCode(data.captchaBase64);
    setInputCaptchaId(data.id);
  };

  //use effects
  useEffect(() => {
    setFocus("name");
    handleCaptcha();
    return () => {
      setCaptchaCode("");
      setInputCaptchaId("");
    };
  }, []);

  return (
    <>
      <ToastContainer rtl/>
      <div className="setting">
        <div className="u-margin-top-medium u-margin-bottom-small-2">
          <HeadingSecondary text="با ما در تماس باشید"/>
        </div>
        <div className="setting__contactus u-margin-top-small-3">
          <form className="setting__contactus__form" onSubmit={handleSubmit(onSubmit)}>
            <div
              className={`setting__contactus__form__row setting__contactus__form__row--name ${errors.name && "u-margin-bottom-small-3"}`}>
              <input type="text" id="name"
                     className={`${errors.name && "input-error"}`} {...register("name", ContactUs.name)}  />
              {errors.name && (
                <p className="error-box__content">{errors.name.message}</p>
              )}
              <label htmlFor="name">نام</label>
            </div>
            <div className={`setting__contactus__form__row ${errors.email && "u-margin-bottom-small-3"}`}>
              <input type="text" id="email"
                     className={`${errors.email && "input-error"}`} {...register("email", ContactUs.email)} />
              {errors.email && (
                <p className="error-box__content">{errors.email.message}</p>
              )}
              <label htmlFor="email">ایمیل</label>
            </div>
            <div className="setting__contactus__form__row setting__contactus__form__row--description">
              <textarea id="description"
                        className={`${errors.description && "input-error"}`} {...register("description", ContactUs.description)} />
              {errors.description && (
                <p className="error-box__content" style={{marginTop: '-0.8rem'}}>{errors.description.message}</p>
              )}
              <label htmlFor="description">توضیحات</label>
            </div>
            <div className="setting__contactus__form__row">
              <div className="captcha-input__img">
                <img
                  className="captcha-input__img--base64"
                  src={`data:image/png;base64, ${captchaCode}`}
                  alt=""
                />
                <RefreshLogo onHandleRefreshLogo={handleCaptcha}/>
              </div>
              <input type="text" maxLength={7} id={inputCaptchaId}
                     className={`u-rtl u-text-right u-color-black ${errors.captcha && "input-error"}`} {...register("captcha", ContactUs.captcha)}
                     autoComplete="off"/>
              {errors.captcha && (
                <p className="error-box__content">{errors.captcha.message}</p>
              )}
              <label htmlFor="email">کد امنیتی</label>
            </div>
            <button
              className="btn btn--primary u-width-100 u-margin-top-medium-8 u-margin-bottom-big"
              disabled={successMessage}
              type={`${isLoading ? "button" : "submit"}`}
            >
              {!isLoading ? (
                <div className="u-d-flex u-align-item-center u-justify-content-center ">
                <span className="u-d-flex u-align-item-center u-justify-content-center u-padding-left-small-1">
                  <SendMessageIcon/>
                </span>
                  <span>ارسال پیام</span>
                </div>
              ) : (
                <DotLoading/>
              )}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default SettingContactUs;
